<template>
  <LoadingSpinner v-if="!cotizacion || !agente || !cotizacionDetalle" />
  <section class="col-md-11 mx-auto" v-else>
    <section class="p-md-5">
      <div class="row">
        <div class="p-3 pt-4 pb-5 card-header bg-transparent">
          <div
            class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-2"
          >
            <router-link
              :to="{
                name: 'cotizacion-unidades-nueva',
              }"
            >
              <ArgonButton size="sm" color="dark" icon="ri-add-line"
                >Nueva cotización</ArgonButton
              >
            </router-link>
            <ArgonButton
              size="sm"
              color="dark"
              icon="ri-file-copy-line"
              @click="copiarUrlAprobacion"
              >Copiar url aprobación</ArgonButton
            >
            <a
              class="btn btn-light btn mb-0 d-flex flex-row align-items-center justify-content-center gap-2 btn-sm"
              :href="`${urlEndpoint}public/cotizaciones/unidad/${cotizacion.token}/preview?download=true`"
              target="_blank"
              ><i class="ri ri-download-line me-2"></i>Descargar formato</a
            >
          </div>
        </div>
      </div>
      <iframe
        :src="`${urlEndpoint}public/cotizaciones/unidad/${token}/preview#toolbar=0`"
        title="PDF embebido"
        allowfullscreen
        class="w-100 border rounded"
        style="height: 95vh"
      ></iframe>
    </section>
    <div class="row">
      <section class="col-lg-6">
        <div class="text-secondary mb-4">
          <h5>Datos generales</h5>
        </div>
        <div class="table-responsive">
          <table
            id="tablaInformacionGeneral"
            class="table table-sm table-striped table-bordered table-hover table-condensed text-sm"
          >
            <thead>
              <tr>
                <th>Arrendamiento</th>
                <td>
                  {{ cotizacion.arrendamiento }}<br />
                  {{ cotizacion.descripcion }}
                </td>
              </tr>
              <tr>
                <th>Cliente</th>
                <td>
                  {{ cotizacion.cliente }}<br />
                  {{ cotizacion.atencion }}
                </td>
              </tr>
              <tr>
                <th>Flujo</th>
                <td>
                  {{ cotizacion.flujo_cliente }}
                </td>
              </tr>
              <tr>
                <th>Valor</th>
                <td>${{ formatoMoneda(cotizacion.valor, false) }}</td>
              </tr>
              <tr>
                <th>Anticipo</th>
                <td>
                  ${{ formatoMoneda(cotizacion.anticipo, false) }} ({{
                    cotizacion.porcentaje_anticipo
                  }}%)
                </td>
              </tr>
              <tr>
                <th>Capital</th>
                <td>${{ formatoMoneda(cotizacion.capital, false) }}</td>
              </tr>
              <tr>
                <th>Monto financiado</th>
                <td>
                  ${{ formatoMoneda(cotizacion.monto_financiado, false) }}
                </td>
              </tr>
              <tr>
                <th>Rentas</th>
                <td>{{ cotizacion.rentas }}</td>
              </tr>
              <tr>
                <th>Seguro</th>
                <td>
                  ${{ formatoMoneda(cotizacion.seguro, false) }} -
                  <span>
                    {{
                      cotizacion.seguro_financiado == 1
                        ? "Financiado"
                        : "Contado"
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>Accesorios</th>
                <td>${{ formatoMoneda(cotizacion.accesorios, false) }}</td>
              </tr>
              <tr>
                <th>Comisión</th>
                <td>
                  ${{ formatoMoneda(cotizacion.comision, false) }} ({{
                    cotizacion.porcentaje_comision
                  }}%)
                </td>
              </tr>
              <tr>
                <th>Tasa</th>
                <td>{{ cotizacion.porcentaje_tasa }}%</td>
              </tr>
              <tr>
                <th>Descuentos iniciales</th>
                <td>
                  ${{ formatoMoneda(cotizacion.descuentos_iniciales, false) }}
                </td>
              </tr>
              <tr>
                <th>Tasa periódica</th>
                <td>{{ cotizacion.tasa_periodica }}%</td>
              </tr>
              <tr>
                <th>Fondeo</th>
                <td>{{ cotizacion.fondeo }}%</td>
              </tr>
              <tr>
                <th>TIIE</th>
                <td>{{ cotizacion.tiie }}%</td>
              </tr>
            </thead>
          </table>
        </div>
      </section>
      <section class="col-lg-6">
        <div class="text-secondary mb-4">
          <h5>Detalle por plazo</h5>
        </div>
        <template v-for="cd in cotizacionDetalle" :key="cd.id">
          <div class="table-responsive">
            <table class="table table-sm table-bordered text-sm">
              <thead>
                <tr>
                  <th colspan="2" class="bg-light fw-bold">
                    {{ cd.plazo }} meses
                    <ArgonBadge v-if="cd.aprobada == 1">Aprobada</ArgonBadge>
                  </th>
                </tr>
                <tr>
                  <th>Renta</th>
                  <td>${{ formatoMoneda(cd.renta, false) }}</td>
                </tr>
                <tr>
                  <th>Seguro</th>
                  <td>${{ formatoMoneda(cd.seguro_mensual, false) }}</td>
                </tr>
                <tr>
                  <th>Rentas en depósito</th>
                  <td>{{ cd.renta_deposito }}</td>
                </tr>
                <tr>
                  <th>Residual</th>
                  <td>
                    ${{ formatoMoneda(cd.residual, false) }} ({{
                      cd.residual_porcentaje
                    }}%)
                  </td>
                </tr>
                <tr>
                  <th>TIIR</th>
                  <td>{{ cd.tir }}%</td>
                </tr>
              </thead>
            </table>
          </div>
        </template>
        <div></div>
      </section>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useCotizacionUnidad } from "@/composables/useCotizacionUnidad";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import useUtil from "@/composables/useUtil";
import ArgonBadge from "@/components/ArgonBadge.vue";
const { formatoMoneda } = useUtil();

const {
  agente,
  copiarUrlAprobacion,
  cotizacion,
  cotizacionDetalle,
  getById,
  token,
  urlEndpoint,
} = useCotizacionUnidad();

onMounted(async () => {
  await getById();
});
</script>

<style scoped>
.bg-dark {
  background: #000 !important;
}

input {
  background-color: transparent;
  border: none;
}

.table th {
  width: 30%;
  background-color: #f8f9fa;
}

.table td th {
  vertical-align: middle;
  align-items: center;
}
</style>
